import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsRemoteControlStyles: IStyles = {
    wrapper: {
        maxWidth: 520,
    },
    title: {
        fontSize: textSizes.normal,
    },
    hint: {
        fontSize: textSizes.normal,
        opacity: 0.7,
        marginTop: -24,
        marginBottom: 24,
        lineHeight: 1.35,
    },
    radioWrapper: {
        ...grid.row,
        ...grid.fullWidth,
        marginTop: 10,
        marginBottom: 36,
    },
    radioColumn: {
        ...grid.col,
        ...grid.fullWidth,
        marginTop: 10,
        marginBottom: 36,
        gap: 12,
    },
    radio: {
        ...grid.mr_md,
    },
    radioBlock: {
        ...grid.mb_mini,
        maxWidth: '100%',
    },
    titleWithLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
    },
    wikiLink: {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        color: 'inherit',
        opacity: 0.65,
        lineHeight: 0,

        '&:hover': {
            opacity: 1,
        },
    },
    checkboxSection: {
        ...grid.col,
        marginTop: 10,
        marginBottom: 36,
        gap: 10,
    },
    checkboxWrapper: {
        ...grid.mb_mini,
    },
    labelClassName: {
        fontSize: textSizes.normal,
    },
    switchWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 24,
    },
    switch: {
        marginLeft: 10,
    },
    masterGroupTitle: {
        marginBottom: 36,
    },
    masterAutoSelectWrapper: {
        marginTop: 36,
    },
    button: {
        marginTop: 10,
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
}

addStyles(deviceSettingsRemoteControlStyles)
export default deviceSettingsRemoteControlStyles
